"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _Table = _interopRequireDefault(require("@mui/material/Table/Table"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow/TableRow"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell/TableCell"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody/TableBody"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _styles = require("@mui/material/styles");
var _theme = require("../../theme");
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable require-jsdoc */
var ClassAndDivisionDetailsModal = function ClassAndDivisionDetailsModal(props) {
  var theme = (0, _styles.useTheme)();
  var styles = {
    table: _theme.globalStyles.table,
    tableHeading: {
      fontFamily: _theme.fonts.type.medium,
      color: "#FFFFFF",
      "&.MuiTableCell-root": {
        padding: "4px 30px"
      }
    },
    cell: {
      "&.MuiTableCell-root": {
        padding: "4px 30px"
      },
      color: _theme.colors.mainTextGrey
    },
    row: {
      "&.MuiTableRow-root": {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.whitelabel.buttonTextColor,
          "&:hover": {
            backgroundColor: _theme.colors.lightHoverGrey
          }
        },
        backgroundColor: _theme.colors.backgroundGrey,
        "&:hover": {
          backgroundColor: _theme.colors.lightHoverGrey
        }
      }
    },
    noPadding: {
      padding: 0,
      borderRadius: "0px"
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
    open: props.showModal,
    close: props.hideModal,
    title: _i18n["default"].t(_tokens["default"].labels.admin.classAndDivisionDetails),
    customFormStyle: styles.noPadding,
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    customContainerStyle: {
      width: 750
    },
    maxWidth: "lg"
  }, /*#__PURE__*/_react["default"].createElement(_Table["default"], {
    padding: 0
  }, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
    sx: {
      backgroundColor: theme.palette.primary.main,
      borderTop: "2px solid #FFFFFF"
    }
  }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.className)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: _objectSpread(_objectSpread({}, styles.tableHeading), {}, {
      width: "35%"
    })
  }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.classDescription)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: _objectSpread(_objectSpread({}, styles.tableHeading), {}, {
      width: "35%"
    })
  }, _i18n["default"].t(_tokens["default"].labels.effectiveDate)))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, _sbUtils.helpers.sortObjByTitle(props.classesData).map(function (classID) {
    var classData = props.classesData[classID];
    return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
      key: classData.classID,
      hover: true,
      sx: styles.row
    }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread({
        border: "none"
      }, styles.cell)
    }, classData.title), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%"
      })
    }, classData.description), !classData.status ? /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%",
        "&.MuiTableCell-root": {
          padding: "4px 30px 0px 70px"
        }
      })
    }, "-") : /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%"
      })
    }, dates.getStartOfDay(classData.classEffectiveDate, "ll")));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/_react["default"].createElement(_Table["default"], {
    padding: "none"
  }, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
    sx: {
      backgroundColor: theme.palette.primary.main,
      borderTop: "2px solid #FFFFFF"
    }
  }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: styles.tableHeading
  }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.divisionName)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: _objectSpread(_objectSpread({}, styles.tableHeading), {}, {
      width: "35%"
    })
  }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.divisionDescription)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    padding: "none",
    sx: _objectSpread(_objectSpread({}, styles.tableHeading), {}, {
      width: "35%"
    })
  }, _i18n["default"].t(_tokens["default"].labels.effectiveDate)))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, _sbUtils.helpers.sortObjByTitle(props.divisions).map(function (divisionID) {
    var divisionData = props.divisions[divisionID];
    return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
      key: divisionData.title,
      hover: true,
      sx: styles.row
    }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread({
        border: "none"
      }, styles.cell)
    }, divisionData.title), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%"
      })
    }, divisionData.description), divisionData.eligibilityOverrideDate || divisionData.accountEffectiveDate ? /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%"
      })
    }, divisionData.eligibilityOverrideDate ? dates.getStartOfDay(divisionData.eligibilityOverrideDate, "ll") : dates.getStartOfDay(divisionData.accountEffectiveDate, "ll")) : /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      padding: "none",
      sx: _objectSpread(_objectSpread({
        border: "none"
      }, styles.cell), {}, {
        width: "35%",
        "&.MuiTableCell-root": {
          padding: "4px 30px 0px 70px"
        }
      })
    }, "-"));
  })))), /*#__PURE__*/_react["default"].createElement("span", {
    id: "classAndDivisionDetails"
  }));
};
var _default = exports["default"] = ClassAndDivisionDetailsModal;